import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { useGetVideoQuery } from "../../features/videos/videosApi";
import getLastPlayedVideo from "../../utils/getLastPlayedVideo";
import useAuth from "../hooks/useAuth";

export default function StudentsPublicRoute({ children }) {
  const isloggedIn = useAuth();
  const auth = useSelector((state) => state.auth);
  const { data: firstVideo, isSuccess, isLoading } = useGetVideoQuery(1);

  return !isloggedIn ? (
    // if not loggedIn show children
    children
  ) : auth.user.role === "student" ? (
    // if logged in but user is a student then show coursePlayer page
    !isLoading &&
    isSuccess && (
      // send the first video by default
      <Navigate to={`/coursePlayer/${getLastPlayedVideo(firstVideo)}`} />
    )
  ) : (
    // if logged in but user is an admin then show admin dashboard page
    <Navigate to="/admin/dashboard" />
  );
}
